import store from "../index";
import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";
import screenshotsDA from "@/services/da/player-screenshots.service";
import playersDA from "@/services/da/players.service";
import virtualClassesDataAccessService from "@/services/da/virtual-classes.service";
import { AssetStates } from "../types/players";
import { DocumentSnapshot, updateDoc } from "firebase/firestore";

@Module
class PlayerPageModule extends VuexModule {

    data: any = null

    screenshots: any[] = []

    get virtualClassesStateCodes() {
        if (this.data != null && this.data.virtualClassesStateCodes != undefined) {
            const list = Object.keys(this.data.virtualClassesStateCodes)
                .filter(id => !['playerId', 'id'].includes(id))
                .map(id => {
                    let code = this.data.virtualClassesStateCodes[id];
                    code = (typeof code === 'string' ? parseInt(code) : code)
                    return { id, code }
                });
            return list;
        }
        return [];
    }

    get virtualClassesStates() {
        const states: { [key: string]: any } = { [AssetStates.FETCHING]: [] }

        this.virtualClassesStateCodes.forEach((state: { [key: string]: string }) => {
            if (states[state.code] === undefined) {
                states[state.code] = []
            }
            if (parseInt(state.code) < 100) {
                states[AssetStates.FETCHING].push(state)
            }
            states[state.code].push(state)
        })

        const ready = states[AssetStates.READY] != undefined ? states[AssetStates.READY] : []
        const waiting = states[AssetStates.UNPROCESSED] != undefined ? states[AssetStates.UNPROCESSED] : []
        const fetching = states[AssetStates.FETCHING] != undefined ? states[AssetStates.FETCHING] : []
        const error = states[AssetStates.FETCHING_ERROR] != undefined ? states[AssetStates.FETCHING_ERROR] : []
        const deprecated = states[AssetStates.DEPRECATED] != undefined ? states[AssetStates.DEPRECATED] : []
        return { ready, waiting, fetching, error, deprecated }
    }

    @Action
    async load(id: string) {

        const snapshot = await playersDA.getById(id);

        if (snapshot.exists()) {
            const player = { ...snapshot.data() as any, id }

            if (!player.primePlayerId) {
                player.mscreen = await playersDA.mScreenConfigGet(snapshot.id);
            }

            const virtualClasses = await virtualClassesDataAccessService.getBySerialDeviceNumber(player.Serial);

            if (virtualClasses.length > 0) {
                player.virtualClassesStateCodes = virtualClasses[0];
            }
            if (player.StorageInfo) {
                player.StorageInfo.totalSize /= Math.pow(1000, 3)
                player.StorageInfo.usedSize /= Math.pow(1000, 3)
                player.StorageInfo.usagePercentage = (player.StorageInfo.usedSize / player.StorageInfo.totalSize) * 100
            }
            this.update(player);
        }
    }

    @Action
    async enableDownloadTimes(t: any[])
    {
        let args: any = {ContentDownloadTimeDisabled: false};
        if (t.length == 2) {
            const ContentDownloadsStartTime = 'PT' + (t[0].hours) + 'H' + (t[0].minutes > 0 ? t[0].minutes + 'M' : '');
            const ContentDownloadsEndTime = 'PT' + (t[1].hours) + 'H' + (t[1].minutes > 0 ? t[1].minutes + 'M' : '');

            args = {...args, ContentDownloadsStartTime, ContentDownloadsEndTime};
        }

        const snapshot = await playersDA.getById(this.data.id);
        if (snapshot.exists()) {
            await updateDoc(snapshot.ref, args);
        }
    }

    @Action
    async disableDownloadTimes()
    {
        const ContentDownloadTimeDisabled = true;
        const ContentDownloadsStartTime = null;
        const ContentDownloadsEndTime = null
        const snapshot = await playersDA.getById(this.data.id);
        if (snapshot.exists()) {
            await updateDoc(snapshot.ref, {
                ContentDownloadTimeDisabled,
                ContentDownloadsStartTime,
                ContentDownloadsEndTime
            });
        }
    }

    @Action
    async loadScreenshots(arg: { size: number, beforeTheTime: number, afterTheTime: number, lastSeen: DocumentSnapshot | null }) {

        const { Id } = this.data
        const { size, beforeTheTime, afterTheTime, lastSeen } = arg
        const list = await (new Promise(rs =>
            screenshotsDA.getByPlayerId(Id, size, lastSeen, beforeTheTime, afterTheTime,
                (d: any) => rs(d)))) as any[]
        this.updateScreenshots(list)
    }

    @Mutation
    updateScreenshots(screenshot: any[]) {
        this.screenshots = screenshot
    }

    @Mutation
    update(data: any) {
        this.data = data;
    }

    @Action
    reset() {
        this.resetStates()
    }

    @Mutation
    resetStates() {
        this.data = null;
    }
}
const name = "playerPageModule";

export const playerPageModule = new PlayerPageModule({
    store,
    name,
});
